import {
  MarketPlaceLinksList,
  MarketPlaceListItem,
  MarketPlaceLinkItem,
  AISolutionsBadge,
} from './styles';
import { useTranslatedObject } from '../../utils/translation';
import { FooterNavigationBar, sendGA4Data } from '../../analytics/events';
import { buildLegacyLoginContinueUrl } from '../../utils/helper';

const Resources = () => {
  const footer = useTranslatedObject('footer');

  const handleClick = (label) => {
    sendGA4Data(FooterNavigationBar, { eventCategory: 'Resources & Insights', eventLabel: label });
  };

  return (
    <MarketPlaceLinksList id="resources-list">
      {footer?.resource_links?.map(({ label, url, isNew, openInNewTab }) => {
        const resourceUrl = buildLegacyLoginContinueUrl(url);
        return (
          <MarketPlaceListItem id={`resources-list-item-${label}`} key={label}>
            <MarketPlaceLinkItem
              id={`resources-link-item-${label}`}
              aria-label={label}
              href={resourceUrl}
              target={openInNewTab ? '_blank' : '_self'}
              onClick={() => handleClick(label)}
            >
              {isNew ? (
                <span>
                  {label}
                  <AISolutionsBadge>New!</AISolutionsBadge>
                </span>
              ) : (
                label
              )}
            </MarketPlaceLinkItem>
          </MarketPlaceListItem>
        );
      })}
    </MarketPlaceLinksList>
  );
};

export default Resources;